var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hackReset)?_c('ejs-dialog',{ref:_vm.refName,attrs:{"target":_vm.target,"isModal":_vm.isModal,"width":_vm.width,"height":_vm.height,"header":_vm.header,"buttons":_vm.buttonGroup,"visible":_vm.visible,"showCloseIcon":_vm.closeIcon}},[_c('div',{staticStyle:{"width":"100%","height":"90%"}},[_vm._v(_vm._s(_vm.tipData.tipInfo))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }